import { render, staticRenderFns } from "./Inboundlist.vue?vue&type=template&id=2e112063&scoped=true&"
import script from "./Inboundlist.vue?vue&type=script&lang=js&"
export * from "./Inboundlist.vue?vue&type=script&lang=js&"
import style0 from "./Inboundlist.vue?vue&type=style&index=0&id=2e112063&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e112063",
  null
  
)

export default component.exports